var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScheduleBttnHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_query_builder copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "single-calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Single-device:-SW-update-Copy",
    transform: "translate(-493.000000, -3733.000000)",
    fill: "#F36E21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_query_builder-copy-2",
    transform: "translate(493.000000, 3733.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99202469,0.024691358 C3.58965432,0.024691358 0.024691358,3.59762963 0.024691358,8 C0.024691358,12.4023704 3.58965432,15.9753086 7.99202469,15.9753086 C12.4023704,15.9753086 15.9753086,12.4023704 15.9753086,8 C15.9753086,3.59762963 12.4023704,0.024691358 7.99202469,0.024691358 L7.99202469,0.024691358 Z M8,14.3802469 C4.47491358,14.3802469 1.61975309,11.5250864 1.61975309,8 C1.61975309,4.47491358 4.47491358,1.61975309 8,1.61975309 C11.5250864,1.61975309 14.3802469,4.47491358 14.3802469,8 C14.3802469,11.5250864 11.5250864,14.3802469 8,14.3802469 L8,14.3802469 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "8.39876543 4.01234568 7.20246914 4.01234568 7.20246914 8.79753086 11.3895062 11.3097531 11.9876543 10.3287901 8.39876543 8.19938272"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleBttnHover);
export default __webpack_public_path__ + "static/media/icon_schedule_bttn_hover.0d319b002330547a1b65dccaa49fafbf.svg";
export { ForwardRef as ReactComponent };